import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss']
})

export class LandingPageComponent implements OnInit{
    @Output() setup = new EventEmitter<any>();
    princepipes:boolean = false;
    project: string = "";
    constructor(private router: Router){
        this.project = this.getParameterByName('project', window.location.href);
        if (this.project === 'berrybox') {
            this.project = '91sb';
        }
        setTimeout(()=>{
            if(this.project !== "91sb" && this.project !== "berrybox"){
                this.router.navigate(['/']);
                this.setup.emit('signup');
            }
        }, 100)
        
    }
    ngOnInit(){
        const webshop = JSON.parse(sessionStorage.getItem('webshopDetail'));
        if(webshop && webshop.DomainName === "princepipes"){
            this.princepipes = true;
        }

    }
    
    signup(){
        let params: any = {};
        if (this.project === '91sb') {
            params['IsSb91'] = 'Y';
        } else if (this.project === 'berrybox') {
            params['berrybox'] = 'Y';
        }
        const queryString = new URLSearchParams(params).toString();
        const url = `${location.origin}?${queryString}`;
        window.open(url, '_blank');
        // this.router.navigate(['/'], { queryParams: params, replaceUrl: false });
        // this.setup.emit('signup')
    }

    importuser() {
        if (location.host.split('.')[1] === 'constients') {
            window.open(`http://${this.project}.constient.us/admin-login` , '_blank');
        } else {
            window.open(`https://${this.project}.rewardkartadmin.in/admin-login` , '_blank');
        }
        
        // window.location.href = 'https://91sb.rewardkartadmin.in';
    }

    enqyiryForm(){
        let url = `${location.origin}/enquiryform`;
        window.open(url , '_blank');
        // this.router.navigate(['/enquiryform']);
        // this.setup.emit('enquiryform')
    }

    getParameterByName(name, url) {
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&|]" + name + "(=([^&#|]*)|&|#|$)", 'i'),
        results = regex.exec(url);
        if (!results)
          return null;
        if (!results[2])
          return '';
        return results[2].replace(/\+/g, " ");
      }
}